export default {
  合同管理信息列表: "合約管理資訊列表",
  申请合同审查: "申請合約審查",
  合同审查申请: "合約審查申請",
  合同基础信息: "合約基礎資訊",
  供应商编号: "供應商編號",
  请选择供应商: "請選擇供應商",
  供应商名称中文: "供應商名稱（中文）",
  供应商名称英文: "供應商名稱（英文）",
  自动带出: "自動帶出",
  合同名称: "合約名稱",
  请输入合同名称: "請輸入合約名稱",
  请输入: "請輸入",
  合同编号: "合約編號",
  请输入合同编号: "請輸入合約編號",
  合同总金额币种: "合約總金額/幣種",
  请输入合同金额: "請輸入合約金額",
  请选择币种: "請選擇幣種",
  合同有效期: "合約有效期",
  请选择合同有效期: "請選擇合約有效期",
  合同主要内容: "合約主要內容",
  请输入合同主要内容: "請輸入合約主要內容",
  合同文件: "合約文件",
  相关文件: "相關文件",
  合同文件信息: "合約文件資訊",
  双方已签署合同: "雙方已簽署合約",
  合同相关附件: "合約相關附件",
  KMS合同文件編號: "KMS合約文件編號",
  请输入KMS合同文件編號: "請輸入KMS合約文件編號",
  申请人信息: "申請人資訊",
  申请人: "申請人",
  请选择申请人: "請選擇申請人",
  部门: "部門",
  部门主管: "部門主管",
  工厂: "工廠",
  请选择工厂: "請選擇工廠",
  合同来源: "合約來源",
  请选择合同来源: "請選擇合約來源",
  已批准采购申请表編號: "已批准採購申請表編號",
  附件上传: "附件上傳",
  合同审查信息: "合約審查資訊",
  合同类别: "合約類別",
  请选择合同类别: "請選擇合約類別",
  合同子类别: "合約子類別",
  请选择合同子类别: "請選擇合約子類別",
  合同描述: "合約描述",
  请输入合同描述: "請輸入合約描述",
  合同审查项: "合約審查項",
  合同检查项: "合約檢查項",
  公司标准: "公司標準",
  实际: "實際",
  请选择: "請選擇",
  请输入备注: "請輸入備註",
  合同上传方: "合約上傳方",
  流程状态: "流程狀態",
  当前节点: "當前節點",
  供应商: "供應商",
  供应商名称: "供應商名稱",
  用户部门: "用戶部門",
  操作: "操作",
  編輯: "編輯",
  查看: "查看",
  重新提交: "重新提交",
  删除: "刪除",
  草稿: "草稿",
  已驳回: "已駁回",
  审批中: "審批中",
  已存档: "已存檔",
  暂存: "暫存",
  提交: "提交",
  关闭: "關閉",
  审批成功: "審批成功",
  暂存已提交: "暫存已提交",
  申请已提交: "申請已提交",
  提交成功: "提交成功",
  供应商提供: "供應商提供",
  删除成功: "刪除成功",
  BF合同模版: "BF合約模版",
  常规服务年度合同更新与同一供应商续签:
    "常規服務年度合約更新(與同一供應商續簽)",
  不能提供合同但有采购订单必须说明理由:
    "不能提供合約但有採購訂單(必須說明理由)",
  "未上传合同：查询不到目标文件，请先上传合同":
    "未上傳合同：查詢不到目標文件，請先上傳合同",
  "合同正在审核，请耐心等待": "合同正在審核，請耐心等待",
  合同审核失败: "合同審核失敗",
  查看AI审核结果: "查看 AI 審核結果",
  合同審核: "合同審核",
  AI審核: "AI審核",
  审查结果: "審查結果",
  高: "高",
  中: "中",
  低: "低",
  暂无: "暫無",
  检测结果为空: "檢測結果為空",
  存在问题: "存在問題",
  建议修改内容: "建議修改內容",
  风险程度: "風險程度",
  检测正常: "檢測正常",
};
